module.exports = __webpack_public_path__ + "static/media/Rachel K.65e3e647.png";